import { Show } from 'solid-js'
import { cn } from '~/lib/utils'

type Variant = 'hero' | 'card'

export function TimeLabel(props: {
  seconds: number
  prefix?: string
  variant?: Variant
  class?: string
}) {
  const v = () => props.variant ?? 'card'

  const formatted = () => {
    const total = Math.max(0, Math.floor(props.seconds))
    const d = Math.floor(total / 86400)
    const h = Math.floor((total % 86400) / 3600)
    const m = Math.floor((total % 3600) / 60)
    const s = total % 60
    if (d >= 1) return `${d}d ${h}h`
    if (h >= 1) return `${h}h ${m}m`
    return `${m}m ${s}s`
  }

  return (
    <span
      class={cn(
        'whitespace-nowrap',
        v() === 'hero' ? 'text-white' : 'text-[#888]',
        props.class,
      )}
    >
      <Show when={props.prefix}>
        <span>{props.prefix} </span>
      </Show>
      {formatted()}
    </span>
  )
}
